import {Box, CircularProgress} from '@mui/material';
import {useContext} from 'react';
import {AppContext} from '../../contexts/app/context';
import {AppContextType} from '../../contexts/app/types';
import {ThemeMode} from '../../enums/theme-mode';

/**
 * Main splash screen.
 */
export const SplashScreen = () => {
  // Get context
  const appContext: AppContextType = useContext(AppContext);

  // Default result
  return (
    <Box
      sx={{
        // https://next.material-ui.com/customization/palette/
        bgcolor: 'background.default',
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 9999,
      }}
    >
      <CircularProgress
        color={appContext.state.currentThemeMode === ThemeMode.Dark ? 'control' : 'primary'}
        size={80}
      />
    </Box>
  );
};
